module.exports = __webpack_public_path__ + "static/media/New_Series_3_Ep7_Food_as_medicine_Tablet.078906d9.jpg";